module.exports = __webpack_public_path__ + "img/appBarMovile.f84ad0d1.png";